export default "__VITE_ASSET__CtHtaGGZ__"